<template>
  <transition name="el-fade-in-linear">
    <div v-show="transitionshow">

      <el-form ref="create" :model="create" :rules="rules" label-width="90px" size="small">
        <div class="backborder3" v-loading="thumbloading" style="overflow:hidden;position:relative">

          <div style="font-size:0">
            <input type="file" id="adimg" style="display:none" @change="getadimgb($event)" />
            <div
              style="float:left;position:relative;width:60px;height:60px;margin:0 10px 10px 0;display:inline-block;border-radius:6px;border:1px solid rgba(221,221,221,.7);background:rgba(221,221,221,.4)">
              <a @click="getadimga()"
                style="cursor:pointer;width:60px;height:60px;border-radius:6px;display:flex;justify-content:center;align-items:center">
                <img src="../../static/images/no-img.png" style="max-width:85%;max-height:85%;border-radius:6px" />
              </a>
            </div>

            <div v-for="(item, index) in create.thumb" :key="index"
              style="float:left;position:relative;width:60px;height:60px;margin:0 10px 10px 0;display:inline-block;border-radius:6px;border:1px solid rgba(221,221,221,.7);background:rgba(221,221,221,.4)">
              <a
                style="width:60px;height:60px;border-radius:6px;display:flex;justify-content:center;align-items:center">
                <img :src="GLOBAL.staticUrl + item.url" style="max-width:85%;max-height:85%;border-radius:6px" />
              </a>
              <a @click="closethumb(index)"
                style="position:absolute;width:18px;height:18px;top:0;right:0;border-radius:50%;margin:-8px -8px 0 0;cursor:pointer;">
                <img src="../../assets/error.png" style="width:18px;height:18px;" />
              </a>
              <a @click="selectdefaultthumb(index)"
                style="position:absolute;width:18px;height:18px;bottom:0;right:0;border-radius:50%;margin:0 -8px -8px 0;cursor:pointer;">
                <img
                  :src="item.isdefault == 0 ? require('../../assets/right_default.png') : require('../../assets/right_select.png')"
                  style="width:18px;height:18px;" />
              </a>
            </div>

          </div>


          <!--
			<ul class="imglists">
				<li>
					<input type="file" id="adimg" style="display:none" @change="getadimgb($event)"/>
					<a @click="getadimga()"><img src="../../static/images/no-img.png" /></a>
				</li>
				<li v-for="(item,index) in create.thumb" :key="index">
					<img :src="GLOBAL.staticUrl+item.url" />
					<a @click="closethumb(index)" class="thumbclose">-</a>
					<a @click="selectdefaultthumb(index)" :class="item.isdefault==0 ? 'thumbdefault' : 'thumbdefault selects' ">√</a>
				</li>
			</ul>
			-->

        </div>
        <div class="backborder3" style="margin-top:10px">
          <el-col :span="24">
            <el-col :span="6">
              <el-form-item label="商品名称" prop="name">
                <el-input v-model="create.name" @blur="getCode"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="商品编号" prop="number">
                <el-input v-model="create.number"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="商品规格" prop="spec"><el-input v-model="create.spec"></el-input></el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="拼音编码" prop="pym">
                <el-input v-model="create.pym"></el-input>
              </el-form-item>
            </el-col>
          </el-col>
        </div>
        <div class="backborder3" style="margin-top:10px">
          <el-col :span="6">
            <el-form-item label="商品类型" prop="costtype">
              <el-select v-model="create.goodstype">
                <el-option label="库存商品" value="0"></el-option>
                <el-option label="虚拟商品" value="1"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="基本条码" prop="basebarcode">
              <el-input v-model="create.basebarcode" @blur="addsetBarcode(0)"
                @keyup.enter.native="getBarcodeInfo"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="商品产地" prop="origin">
              <el-input v-model="create.origin"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="预警库存" prop="origin">
              <el-tooltip class="item" effect="dark" content="商品采购预警数量，当商品可用库存数量低于该数量时进行采购预警" placement="top">
                <el-input v-model="create.warnnumber" />
              </el-tooltip>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-col :span="6">
              <el-form-item label="有效期" prop="validity">
                <el-col :span="25">
                  <el-input v-model="create.validity">
                    <template slot="append">
                      <el-button @click="checkaddvalidity">{{ validityunitname }}</el-button>
                    </template>
                  </el-input>
                </el-col>
              </el-form-item>
            </el-col>
            <!-- <el-col :span="6">
              <el-form-item label="是否启用效期/批次" prop="validity" label-width="140px">
                <el-col :span="25">
                  <el-switch active-color="#67C23A" inactive-color="#cccccc"></el-switch>
                </el-col>
              </el-form-item>
            </el-col> -->
            <el-col :span="6">
            <el-form-item label="预警天数" prop="early_warning_day">
                <el-input v-model="create.early_warning_day" >
                  <template slot="append">天</template>
                </el-input>
            </el-form-item>
          </el-col>

          </el-col>
          <el-col :span="24">
            <el-col :span="18">
              <el-form-item label="商品备注" prop="note">
                <el-input v-model="create.note"></el-input>
              </el-form-item>
            </el-col>
          </el-col>
        </div>
        <div class="backborder3" style="margin-top:10px">
          <el-col :span="6">
            <el-form-item label="成本算法" prop="costtype">
              <el-select v-model="create.costtype" placeholder="成本算法">
                <el-option label="移动加权平均" value="0"></el-option>
                <el-option label="先进先出法" value="1"></el-option>
                <el-option label="后进先出法" value="2"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="商品分类" prop="catid">
              <el-cascader :options="categorylistsearch" v-model="create.catid"></el-cascader>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="商品品牌" prop="brandid">
              <el-select v-model="create.brandid" filterable placeholder="请选择商品品牌">
                <el-option label="不分品牌" value="0"></el-option>
                <el-option v-for="(item, index) in brandlists" :label="item.showlable" :value="item.id" :key="index">
                  <span style="float: left">{{ item.name }}</span>
                  <span style="float: right; color: #C0C4CC; font-size: 13px">{{ item.py }}</span>
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="供应商家" prop="supplierid">
              <el-select v-model="create.supplierid" filterable placeholder="请选择供应商">
                <el-option label="不选择供应商" value="0"></el-option>
                <el-option v-for="(item, index) in allapplylists" :label="item.apply_name" :value="item.id"
                  :key="index"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="一品多码">
              <el-input type="textarea" :rows="3" placeholder="多个条形码请以换行分隔" v-model="create.morebarcode"
                @blur="addmorecode"></el-input>
            </el-form-item>
          </el-col>
        </div>
        <div class="backborder3" style="margin-top:10px">
          <el-col :span="24">
            <el-table :data="projectData" style="width: 100%">
              <el-table-column fixed prop="project" label="单位"></el-table-column>
              <el-table-column label="单位名称" prop="unit" align="center">
                <template slot-scope="scope"><el-input v-model="create.unit[scope.row.index]"
                    size="small"></el-input></template>
              </el-table-column>
              <el-table-column label="数量关系" align="center">
                <template slot-scope="scope">
                  <el-input v-model="create.num[scope.row.index]" @blur="changeprice(scope.row.index, 'create')"
                    v-if="scope.row.index == 0" readonly><template slot="append" v-if="create.unit[0] != ''"
                      size="small">{{ create.unit[0] }}</template></el-input>
                  <el-input v-model="create.num[scope.row.index]" @blur="changeprice(scope.row.index, 'create')"
                    v-if="scope.row.index > 0"><template slot="append" v-if="create.unit[0] != ''" size="small">{{
                      create.unit[0] }}</template></el-input>
                </template>
              </el-table-column>
              <el-table-column label="条形码" align="center">
                <template slot-scope="scope">
                  <el-input v-model="create.barcode[scope.row.index]"
                    @blur="addunitcode(create.barcode[scope.row.index], scope.row.index, 0)" size="small"></el-input>
                </template>
              </el-table-column>
              <el-table-column label="进货价(元)" align="center">
                <template slot-scope="scope">
                  <el-input v-model="create.buy[scope.row.index]"
                    @blur="changecolprice(scope.row.index, 'buy', -1, 'create')" size="small"></el-input>
                </template>
              </el-table-column>
              <el-table-column label="批发价(元)" align="center">
                <template slot-scope="scope">
                  <el-input v-model="create.sell[scope.row.index]"
                    @blur="changecolprice(scope.row.index, 'sell', -1, 'create')" size="small"></el-input>
                </template>
              </el-table-column>
              <el-table-column label="零售价(元)" align="center">
                <template slot-scope="scope">
                  <el-input v-model="create.market[scope.row.index]"
                    @blur="changecolprice(scope.row.index, 'market', -1, 'create')" size="small"></el-input>
                </template>
              </el-table-column>
              <el-table-column v-for="(ip, key) in customerClass" prop="groupname" :label="ip.groupname" :key="key"
                align="center">
                <template slot-scope="scope">
                  <el-input v-model="create.other[scope.row.index][key]"
                    @blur="changecolprice(scope.row.index, 'other', key, 'create')" size="small"></el-input>
                </template>
              </el-table-column>
            </el-table>
          </el-col>
          <el-col :span="24" style="text-align:right;margin:15px 0 2% 0">
            <el-button size="small" type="primary" :loading="createLoading" @click="createSave">保
              存</el-button>
          </el-col>
        </div>
      </el-form>

      <el-dialog title="有效期" :visible.sync="validityDialog" width="30%">
        <el-table :data="validityunits">
          <el-table-column prop="name" label="类型" style="width:70%" align="left"></el-table-column>
          <el-table-column label="操作" style="width:30%" align="center">
            <template slot-scope="scope">
              <el-button type="primary" size="mini" icon="el-icon-check"
                @click="ensurevalidity(scope.row)">确定</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-dialog>

    </div>
  </transition>
</template>

<script>

export default {
  data() {
    return {
      actionauth: '', //操作功能权限
      url: this.GLOBAL.domain + "Product/index",
      transitionshow: true,
      create: {
        act: 'add',
        token: this.$cookies.get('token'),
        name: '',
        number: '',
        basebarcode: '',
        spec: '',
        pym: '',
        costtype: '0',
        goodstype: '0',
        validity: '',
        early_warning_day: '',
        validityunit: 1,
        catid: [],
        brandid: '',
        origin: '',
        warnumber: '',
        note: '',
        morebarcode: '',
        unit: [],
        num: [],
        barcode: [],
        buy: [],
        sell: [],
        market: [],
        other: {
          0: [],
          1: [],
          2: []
        },
        thumb: [],
      },
      projectData: [{
        index: 0,
        project: '基本单位'
      }, {
        index: 1,
        project: '辅助单位'
      }, {
        index: 2,
        project: '辅助单位'
      }],
      rules: {
        name: [ //商品名称
          { required: true, message: '请输入商品名称', trigger: 'blur' },
        ],
        number: [ //编号
          { required: true, message: '请输入编号', trigger: 'blur' },
          { min: 1, max: 100, message: '长度在 1 到 10 个字符' },
          { pattern: /^[A-Za-z0-9]+$/, message: '编号只能为字母和数字' }
        ],
        catid: [ //商品类型
          { required: true, message: '请选择商品分类', trigger: 'blur' }
        ],
        costtype: [ //成本算法
          { required: true, message: '请选择成本', trigger: 'blur' }
        ],
        supplierid: [ //商品供应商
          { required: true, message: '请选择商品供应商', trigger: 'blur' }
        ],
      },
      validityunitname: '日',
      validityunits: [ //有效期时间类型
        { id: 1, name: '日' },
        { id: 2, name: '月' },
        { id: 3, name: '年' },
      ],
      categorylistsearch: [],
      brandlists: [],
      allapplylists: [],
      customerClass: [],
      createLoading: false,
      validityDialog: false,
      allapplyquery: {
        url: this.GLOBAL.domain + "Product/index",
        act: 'getapplyAll',
        token: this.$cookies.get('token'),
      },
      thumbloading: false,

    }
  },
  mounted() {
    this.getactionauth();
    this.getCategoryList();
    this.getAllapplylists();
    this.getBrand();
    this.create.num.splice(0, 1, 1);
  },
  methods: {

    /** 获取操作功能权限 **/
    getactionauth() {
      var data = this.$cookies.get('actionauth');
      data = JSON.parse(data);
      this.actionauth = data;
    },

    /** 获取分类列表 **/
    getCategoryList() {
      var resource = this.$resource(this.url);
      resource.query({ act: 'getcatelist', token: this.$cookies.get('token') }).then((res) => {
        if (res.data.Result > 0) {
          if (res.data.Result == '70001') this.$router.push('/login')
          this.$message.error(res.data.Message);
        } else {
          this.categorylistsearch = JSON.parse(Base64.decode(res.data.Data));
        }
      }).catch((res) => {
        //this.$message.error(this.GLOBAL.errortext);
      });
    },

    /** 获取品牌 **/
    getBrand() {
      var resource = this.$resource(this.GLOBAL.domain + "Brand/index");
      resource.query({ act: 'lists', token: this.$cookies.get('token'), rollpage: 1000 }).then((res) => {
        if (res.data.Result > 0) {
          if (res.data.Result == '70001') this.$router.push('/login')
          this.$message.error(res.data.Message);
        } else {
          var _this = this;
          var thumb = '';
          this.brandlists = JSON.parse(Base64.decode(res.data.Data));
        }
      }).catch((res) => {
        this.$message.error(this.GLOBAL.errortext);
      });
    },

    /** 获取全部列表 **/
    getAllapplylists() {
      var resource = this.$resource(this.allapplyquery.url);
      resource.query(this.allapplyquery).then((res) => {
        if (res.data.Result > 0) {
          if (res.data.Result == '70001') this.$router.push('/login');
          this.$message.error(res.data.Message);;
        } else {
          this.allapplylists = JSON.parse(Base64.decode(res.data.Data));
        }
      }).catch((res) => {
        this.$message.error(this.GLOBAL.errortext);
      });
    },

    /** 获取拼音码 **/
    getCode() {
      var resource = this.$resource(this.GLOBAL.domain + "Pinyin/index",);
      resource.query({ str: this.create.name, token: this.$cookies.get('token') }).then((res) => {
        this.create.pym = res.data.Message;
      });
    },

    /** 基本条形码 **/
    addsetBarcode(id) {
      if (id == 0) var code = this.create.basebarcode;
      if (code != '') {
        //请求后台服务
        var resource = this.$resource(this.url);
        resource.query({ act: 'checkcodeequal', token: this.$cookies.get('token'), code: code, id: id }).then((res) => {
          if (res.data.Result > 0) {
            if (res.data.Result == '70001') this.$router.push('/login')
            this.$message.error(res.data.Message);
          } else {
            var result = Base64.decode(res.data.Data);
            if (result == 1) { //检测到系统里有重复的基本码提示是否添加
              var msg = "基本条码：" + code + "在系统中已经存在，是否继续添加？";
              this.$confirm(msg, '提示', { type: 'warning' }).then(() => {
                if (id == 0) this.create.barcode.splice(0, 1, this.create.basebarcode);
              }).catch(() => {
                this.create.basebarcode = '';
                this.create.barcode.splice(0, 1, this.create.basebarcode);

              });
            } else { //系统里没有重复的基本码
              this.create.barcode.splice(0, 1, this.create.basebarcode);
            }

          }
        }).catch((res) => {
          this.$message.error("获取数据失败，请稍后重试");
        });

      } else {
        if (id == 0) this.create.barcode.splice(0, 1, this.create.basebarcode);
      }
    },

    /** 根据条形码从大数据库中获取信息 **/
    getBarcodeInfo() {
      var resource = this.$resource(this.GLOBAL.domain + "Product/index");
      resource.query({ act: 'getbarcodeinfo', token: this.$cookies.get('token'), barcode: this.create.basebarcode }).then((res) => {
        if (res.data.Result > 0) {
          if (res.data.Result == '70001') this.$router.push('/login')
        } else {
          var info = JSON.parse(Base64.decode(res.data.Data));
          if (info.name != '' && info.name != null) this.create.name = info.name
          if (info.spec != '' && info.spec != null) this.create.spec = info.spec
          if (info.brandid != '' && info.brandid != null) this.create.brandid = info.brandid
          if (info.unit != '' && info.unit != null) this.create.unit.splice(0, 1, info.unit)
        }
      }).catch((res) => {

      });
    },

    /** 获取有效期单位 **/
    checkaddvalidity() {
      this.validityDialog = true;
    },

    /** 联动修改所有价格 **/
    changeprice(i, type) {
      var _this = this;
      this.create.num.forEach(function (e, index) {
        //重置进货价
        _this.create.buy.forEach(function (b, i) {
          if ((e != null || e != '') && (b != null || b != '')) _this.changecolprice(index, 'buy', -1, 'create');
        });
        //重置批发价
        _this.create.sell.forEach(function (b, i) {
          if ((e != null || e != '') && (b != null || b != '')) _this.changecolprice(index, 'sell', -1, 'create');
        });
        //重置市场价
        _this.create.market.forEach(function (b, i) {
          if ((e != null || e != '') && (b != null || b != '')) _this.changecolprice(index, 'market', -1, 'create');
        });
        //重置其它价格
        _this.create.other[index].forEach(function (b, i) {
          if ((e != null || e != '') && (b != null || b != '')) _this.changecolprice(index, 'other', i, 'create');
        });
      });
    },

    /** 联动更新纵列订单价格 **/
    changecolprice(index, keyvalue, sort, type) {
      var _this = this;
      var price;
      var base_price;
      var number;

      number = this.create.num[index]; //获取当前行的单位关系
      if (keyvalue == 'buy') price = this.create.buy[index];
      if (keyvalue == 'sell') price = this.create.sell[index];
      if (keyvalue == 'market') price = this.create.market[index];
      if (keyvalue == 'other') price = this.create.other[index][sort];

      if (number == null || number == '' || price == null || price == 0) return false;

      //联动修改价格
      base_price = price / number;
      if (keyvalue != 'other' && type == 'create') {
        this.create.num.forEach(function (e, index) {
          if (keyvalue == 'buy' && type == 'create' && (e != null || e != '') && (_this.create.buy[index] == null || _this.create.buy[index] == '')) _this.$set(_this.create.buy, index, (base_price * e).toFixed(2));
          if (keyvalue == 'sell' && type == 'create' && (e != null || e != '') && (_this.create.sell[index] == null || _this.create.sell[index] == '')) _this.$set(_this.create.sell, index, (base_price * e).toFixed(2));
          if (keyvalue == 'market' && type == 'create' && (e != null || e != '') && (_this.create.market[index] == null || _this.create.market[index] == '')) _this.$set(_this.create.market, index, (base_price * e).toFixed(2));
        });
      }

      if (keyvalue == 'other' && type == 'create') {
        this.create.num.forEach(function (e, index) {
          if ((e != null || e != '') && (_this.create.other[index][sort] == null || _this.create.other[index][sort] == ''))
            _this.$set(_this.create.other[index], sort, (base_price * e).toFixed(2));
        });
      }
    },

    /** 添加条形码检测 **/
    addunitcode(code, index, id) {
      if (code != '') {
        //请求后台服务
        var resource = this.$resource(this.url);
        resource.query({ act: 'checkunitcodeequal', token: this.$cookies.get('token'), code: code, id: id }).then((res) => {
          if (res.data.Result > 0) {
            if (res.data.Result == '70001') this.$router.push('/login')
            this.$message.error(res.data.Message);
          } else {
            var result = Base64.decode(res.data.Data);
            if (result == 1) { //检测到系统里有重复的基本码提示是否添加
              var msg = "条形码：" + code + "在系统中已经存在，是否继续添加？";
              this.$confirm(msg, '提示', { type: 'warning' }).then(() => {

              }).catch(() => {
                if (id == 0) this.create.barcode.splice(index, 1, '');
              });
            } else { //系统里没有重复的基本码

            }

          }
        }).catch((res) => {
          this.$message.error("获取数据失败，请稍后重试");
        });

      } else {
        if (id == 0) this.create.barcode.splice(index, 1, '');
      }
    },

    /** 新增商品 **/
    createSave() {
      if (this.create.unit[1] != '' && this.create.num[1] != '' && this.create.unit[1] != null && this.create.num[1] != null) {
        this.$confirm('确定设置辅助单位 [ ' + this.create.num[1] + this.create.unit[0] + ' = ' + this.create.num[0] + this.create.unit[1] + ' ] 吗？', '提示', { type: 'warning' }).then(() => {
          this.addSave();
        }).catch(() => {
          this.$message.info('已取消操作!');
        });
      } else {
        this.addSave();
      }
    },


    /** 保存新增商品 **/
    addSave() {
      //校验数据有效性
      this.$refs.create.validate((valid) => {
        if (valid) {
          this.createLoading = true;
          var resource = this.$resource(this.url);
          resource.save(this.create).then((res) => {
            if (res.data.Result > 0) {
              if (res.data.Result == '70001') this.$router.push('/login')
              this.$message.error(res.data.Message);
              this.createLoading = false;
            } else {
              this.$message.success(res.data.Message);
              this.createLoading = false;
              this.reset();
            }
          }).catch((res) => {
            this.$message.error(this.GLOBAL.errortext);
            this.createLoading = false;
          });
        } else {
          return false;
        }
      });
    },

    /** 重置表单 **/
    reset() {
      this.$refs.create.resetFields();
      this.create.unit = [];
      this.create.num = [];
      this.create.barcode = [];
      this.create.buy = [];
      this.create.sell = [];
      this.create.market = [];
      this.create.morebarcode = '';
      this.create.other[0] = [];
      this.create.other[1] = [];
      this.create.other[2] = [];
      this.create.thumb = [];
      this.create.num.splice(0, 1, 1);
    },

    /** 选择有效期单位 **/
    ensurevalidity(obj) {
      this.validityunitname = obj.name;
      this.create.validityunit = obj.id;
      this.validityDialog = false;
    },

    //点击获取活动宣传图
    getadimga() {
      document.getElementById('adimg').click();
    },

    //上传图片
    getadimgb(obj) {
      this.thumbloading = true;
      var file = obj.target.files[0]; //获取文件信息
      var formData = new FormData();
      formData.append('file', file);
      formData.append('sys_type', 'cz');
      formData.append('intranet_token', 'Tzx9VY0OOGjUYZRb');
      var resource = this.$resource(this.GLOBAL.uploadUrl);
      resource.save(formData).then((res) => {
        var data = JSON.parse(Base64.decode(res.body.Data));
        if (data.Result > 0) {
          this.$message.error(data.msg);
        } else {
          this.create.thumb.push({ url: data.imgsrc, isdefault: 0 });
          obj.target.value = '';
        }
        this.thumbloading = false;
      }).catch((res) => {
        this.thumbloading = false;
      });
    },

    //删除图片
    closethumb(index) {
      this.$delete(this.create.thumb, index);
    },

    //选择封面图片
    selectdefaultthumb(index) {
      this.create.thumb.forEach(function (item, i) {
        index == i ? item.isdefault = 1 : item.isdefault = 0;
      });
    },

  }
}
</script>
<style>
.backborder1 {
  background: #fff;
  border-radius: 15px;
  border: 1px solid #ddd;
  padding: 1% 1% 0 1%
}

.backborder3 {
  background: #fff;
  border-radius: 15px;
  border: 1px solid #ddd;
  float: left;
  width: 98%;
  padding: 1% 1% 0 1%;
}

/**
.imglists {float:left;width:100%;padding:0;margin:0 0 10px 0}
.imglists li {position:relative;float:left;width:60px;height:60px;padding:1px;border-radius:6px;border:1px solid #dddddd;margin:20px 1% 0 0;list-style-type:none;background:rgba(221,221,221,.4);border:1px solid rgba(221,221,221,.7);display:flex;justify-content:center;align-items:center;}
.imglists li a {cursor:pointer}
.imglists li img {max-width:85%;max-height:85%;border-radius:6px;}
.thumbclose {color:#fff;font-weight:bold;padding:5px;border-radius:50%;background:#F56C6C;padding:8px 5px;font-size:14px;line-height:2px;position:absolute;margin:-10px 0 0 -10px}
.thumbdefault {color:#fff;font-weight:bold;padding:5px;border-radius:50%;background:#909399;padding:6px 3px;font-size:12px;line-height:2px;position:absolute;margin:62px 0 0 -10px}
.selects {background:#67C23A}
*/
</style>


// WEBPACK FOOTER //
// src/components/inventory/Productadd.vue